import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceUpdatePlanzoneContactsNotificationState = createStateReducer(
  initialState,
  {
    [events.updatePlanzoneContactsSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "updatePlanzoneContacts",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.updatePlanzoneContactsFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "updatePlanzoneContacts",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceUpdatePlanzoneContactsNotificationState };
